import { api } from '../initFetch'

export const addFileFromJobHistoryService = async (file) => {
  const res = await api.post('/p4m/Document/AddFileFromJobHistory', {
    ...file,
  })
  return res.json
}
